<template>
  <div class="users-container">
    <section>
      <el-col class="toolbar">
        <h2>
          <em></em>
          <span>{{$t("admin.users")}}</span>
        </h2>
      </el-col>
      <el-col :span="24" class="toolbar" style="margin-top: 60px;">
        <el-input
          :placeholder="$t('admin.searchUser')"
          icon="search"
          v-model="search"
          :on-icon-click="searchUser"
          @keyup.enter.native="searchUser"
        ></el-input>
      </el-col>
      <div class="user-container">
        <!--列表-->
        <el-table
          :data="users"
          :empty-text="$t('common.noData')"
          highlight-current-row
          v-loading="listLoading"
          min-width="100%"
        >
          <el-table-column prop="username" :label="$t('accountInfo.username')">
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="projectList(scope.row.username)"
              >{{scope.row.username}}</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="email" :label="$t('accountInfo.email')"></el-table-column>
          <el-table-column prop="role" :label="$t('accountInfo.role')"></el-table-column>
          <el-table-column prop="created" :label="$t('accountInfo.registerDate')"></el-table-column>
          <el-table-column :label="$t('common.operation')">
            <template slot-scope="scope">
              <el-switch
                on-value="normal"
                off-value="disabled"
                v-model="scope.row.status"
                on-color="#13ce66"
                off-color="#cdcdcd"
                :disabled="scope.row.role === 'admin'"
                @change="setUser(scope.row)"
              ></el-switch>
              <el-button
                type="primary"
                @click="userStats(scope.row.uid, scope.row.username)"
                style="margin: 0 0 0 20px;"
              >{{$t("stats.title")}}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--分页-->
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          :current-page.sync="curPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          :total="total"
          @size-change="changePageSize"
          @current-change="jumpPage"
        ></el-pagination>
      </div>
      <div class="EndpointBox" :span="12">
        <p>
          {{$t("admin.totalUsers")}}
          <span>{{totalUsers}}</span>{{$t("admin.totalProjects")}}
          <span>{{totalProjects}}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import api from "../../api/api";
import { pattern, resCode, pageDirection } from "../../../server/common/data";
import { formatTime } from "../../common/utils";

export default {
  data() {
    return {
      totalUsers: 0,
      totalProjects: 0,
      search: "",
      pageSize: 10,
      users: [],
      total: 0,
      curPage: 1,
      lastPage: 1,
      listLoading: false
    };
  },
  methods: {
    // echarts
    getTotalCount() {
      api
        .getTotalCount()
        .then(res => {
          if (res.data.CODE === resCode.SUCCESS) {
            this.totalUsers = res.data.DATA.totalUsers;
            this.totalProjects = res.data.DATA.totalProjects;
          }
        })
        .catch(() => {});
    },
    userStats(uid, username) {
      this.$router.push({name: "Statistics", params: {uid: uid, username: username}});
    },
    projectList(username) {
      this.$router.push({name: "Projects", params: {username: username}});
    },
    // 分页
    handleCurrentChange(page, direction, last) {
      this.curPage = page;
      this.getUsers(this.search, this.total, page, direction, last);
      this.lastPage = page;
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.curPage = 1;
      this.lastPage = 1;
      this.jumpPage(1);
    },
    jumpPage(page) { // recognize prevpage and nextpage for performance 
      if (page === (this.lastPage - 1)) {
        this.handleCurrentChange(page, pageDirection.prev, this.users[0].username);
      } else if (page === (this.lastPage + 1)) {
        this.handleCurrentChange(page, pageDirection.next, this.users[this.users.length - 1].username);
      } else {
        this.handleCurrentChange(page, pageDirection.jump, "");
      }
    },
    getUsers(search, total, page, direction, last) {
      this.listLoading = true;
      api
        .getUsers({user: search, total: total, page: page, direction: direction, pagesize: this.pageSize, last: last })
        .then(res => {
          if ((res.data.CODE === resCode.SUCCESS) || (res.data.CODE === resCode.NO_MORE_DATA)) {
            this.users = res.data.DATA.users;
            this.total = res.data.DATA.total;
          } else {
            this.users = [];
            this.total = 0;
          }
          this.users.sort(function(a, b) {
            let la = a.username.toLowerCase();
            let lb = b.username.toLowerCase();
            if (la < lb) {
              return -1;
            } else if (la > lb) {
              return 1;
            } else {
              return 0;
            }
          });
          this.users.forEach(item => {
            item.created = formatTime(item.created, "YYYY-MM-DD HH:mm:ss");
          });          
          this.listLoading = false;
        })
        .catch(() => {});
    },
    setUser(user) {
      api
        .setUser({
          username: user.username,
          status: user.status
        })
        .then(res => {
          // this.listLoading = false;
        })
        .catch(() => {});
    },
    searchUser(key) {
      this.curPage = 1;
      this.getUsers(this.search, 0, 1, pageDirection.init, "");
      this.lastPage = 1;
    },
    isDisableSw(user) {
      return (user.role === "admin");
    }
  },
  mounted() {
    this.getTotalCount();
    this.getUsers(this.search, 0, 1, pageDirection.init, "");
  }
};
</script>

<style lang="scss">
.users-container {
  width: 100%;
  table {
    border: none !important;
    .el-button {
      border: none;
      color: #e7bd62;
      font-size: 14px;
      border-radius: 13px;
      background: #fff0;
    }
    .el-button:focus,
    .el-button:hover {
      color: #fff !important;
    }
  }
  .user-container {
    width: 99%;
    // height: 480px;
    margin: 170px 10px 0;
    border: none;
    border: 1px solid #e2e2e2;
    .el-table {
      border: none !important;
      .el-table th {
        background-color: #f4f7f9 !important;
      }
      tr:nth-child(even) {
        background-color: #f4f7f9 !important;
      }
      tr {
        border-radius: 8px;
        th {
          height: 46px;
          border: none;
        }
        td {
          height: 46px;
          border: none;
        }
      }
      .el-table__column-resize-proxy {
        border: none;
      }
    }
  }
  .EndpointBox {
    font-size: 14px;
    span {
      font-weight: bold;
      margin: 0 4px;
    }
  }
  .el-pagination {
    float: right;
    margin: 30px 2%;
  }
  .el-table:after,
  .el-table:before {
    content: "";
    position: absolute;
    background-color: #f8f9fa;
    z-index: 1;
  }
}
</style>


// WEBPACK FOOTER //
// Users.vue?4726ab62